var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3CelsiusDegree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.49 52.17h.85a18.59 18.59 0 110-28.25h-.85a14.17 14.17 0 000 28.33v-.08z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Celsius_degree.d7367fef.svg";
export { SvgB3CelsiusDegree as ReactComponent };